<script>const defaultSize = 20;
export let size = defaultSize;
const getSize = (size2) => {
  if (size2 < defaultSize) {
    return defaultSize;
  }
  return size2;
};
</script>

<style>@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner {
  animation: rotate 1.5s steps(45) infinite;
  -webkit-mask-image: url("./spinner.svg");
          mask-image: url("./spinner.svg");
}</style>

<div
  class="relative"
  style:width={getSize(size) + "px"}
  style:height={getSize(size) + "px"}>
  <div
    class="spinner bg-p240 mask-center mask-contain mask-no-repeat absolute left-0 top-0 h-full w-full">
  </div>
</div>
